module.exports = __webpack_public_path__ + "img/about3.a8ff663f.png";